import {
  FORM_REQUEST_SET_PROVIDER,
  FORM_REQUEST_SET_PROVIDER_NAME,
  FORM_REQUEST_SET_PATIENT,
  FORM_REQUEST_SET_TYPE,
  FORM_REQUEST_SET_AUTHORIZATION,
  FORM_REQUEST_SET_PAYMENT,
  FORM_REQUEST_RESET,
  FORM_REQUEST_LOADING,
  FORM_REQUEST_ERROR,
  FORM_REQUEST_SET_CARD_NUMBER,
  FORM_REQUEST_SET_CARD_TYPE,
  FORM_REQUEST_SET_REQUEST_ID,
  FORM_REQUEST_PATIENT_INFO,
  FORM_REQUEST_SET_FORMS,
  FORM_REQUEST_SET_FILE_DATA,
  FORM_REQUEST_SET_AUTH_TYPE,
  FORM_REQUEST_SET_ESTIMATE_AUTH,
  FORM_REQUEST_SET_PAYMENT_METHOD,
  FORM_REQUEST_SET_REQUEST_DETAILS,
  FORM_REQUEST_SET_SHOW_PROMPT,
  FORM_REQUEST_SET_RID,
  FORM_REQUEST_SET_GOVT_ID,
  FORM_REQUEST_SET_PATIENT_FORM,
  FORM_REQUEST_SET_SUPPORTING_DOCS,
  FORM_REQUEST_DELETE_SUPPORTING_DOC,
} from 'store/types/formRequest.type';

import { State } from 'store/reducers/formRequest.reducer';
import { AuthFormValues, RequestDetail, GovtId, SupportingDocs, PatientForm } from 'types/requestItem';
import { ThunkAction } from 'redux-thunk';
import { api2 } from '../apis';
import { commonError, commonLoading, commonSuccess } from './common.action';
import { notifyCustomerSurveyRequestActivity } from 'components/modals/CustomerSurvey/customerSurveyEvents';

export const setEstimateAuth = (estimateInitials: string) => ({
  type: FORM_REQUEST_SET_ESTIMATE_AUTH,
  estimateInitials,
});

export const setFormRequestProvider = (provider: any) => ({
  type: FORM_REQUEST_SET_PROVIDER,
  provider,
});

export const setFormRequestProviderName = (name: string) => ({
  type: FORM_REQUEST_SET_PROVIDER_NAME,
  name,
});

export const setFormRequestForms = (forms: any) => ({
  type: FORM_REQUEST_SET_FORMS,
  preload: forms,
});

export const setFormRequestPatientId = (id: string) => ({
  type: FORM_REQUEST_SET_PATIENT,
  id,
});

export const setFormRequestTypeId = (id: string, fileData: any) => ({
  type: FORM_REQUEST_SET_TYPE,
  id,
  fileData,
});

export const setFormRequestFileData = (data: any) => ({
  type: FORM_REQUEST_SET_FILE_DATA,
  preload: data,
});

export const setFormRequestAuthorization = (token: AuthFormValues) => ({
  type: FORM_REQUEST_SET_AUTHORIZATION,
  token,
});

export const setFormRequestGovtId = (data: GovtId, required: boolean = true) => ({
  type: FORM_REQUEST_SET_GOVT_ID,
  data,
  required,
});
export const setPatientForm = (data: PatientForm, required: boolean = true) => ({
  type: FORM_REQUEST_SET_PATIENT_FORM,
  data, required
});

export const setFormRequestSupportingDocs = (docs: SupportingDocs[]) => ({
  type: FORM_REQUEST_SET_SUPPORTING_DOCS,
  docs,
});

export const setFormRequestPaymentMethod = (value: string) => ({
  type: FORM_REQUEST_SET_PAYMENT_METHOD,
  value,
});

export const setFormRequestPayment = (id: string) => ({
  type: FORM_REQUEST_SET_PAYMENT,
  id,
});

export const setFormRequestReset = () => ({
  type: FORM_REQUEST_RESET,
});

export const setFormRequestLoading = (isLoading: boolean) => ({
  type: FORM_REQUEST_LOADING,
  isLoading,
});

export const setFormRequestError = (error: string) => ({
  type: FORM_REQUEST_ERROR,
  error,
});

export const setCardNumber = (cardNumber: string) => ({
  type: FORM_REQUEST_SET_CARD_NUMBER,
  preload: cardNumber,
});

export const setCardType = (cardType: string) => ({
  type: FORM_REQUEST_SET_CARD_TYPE,
  preload: cardType,
});

export const setRequestId = (id: string) => ({
  type: FORM_REQUEST_SET_REQUEST_ID,
  preload: id,
});

export const setPatientInfo = (data: any) => ({
  type: FORM_REQUEST_PATIENT_INFO,
  preload: data,
});

export const setAuthType = (data: string | undefined | null) => ({
  type: FORM_REQUEST_SET_AUTH_TYPE,
  preload: data,
});
export const setRequestDetails = (data: RequestDetail, stepChange: boolean = true) => ({
  type: FORM_REQUEST_SET_REQUEST_DETAILS,
  payload: data,
  stepChange,
});
export const setFormRequestRid = (rid: number) => ({ type: FORM_REQUEST_SET_RID, rid });
export const setShowPrompt = (flag: boolean, data?: RequestDetail) => ({
  type: FORM_REQUEST_SET_SHOW_PROMPT,
  flag,
  data,
});
export const deleteFormSupportingDoc = (fileId: number) => ({ type: FORM_REQUEST_DELETE_SUPPORTING_DOC, fileId });

export type Actions =
  | ReturnType<typeof setFormRequestProvider>
  | ReturnType<typeof setFormRequestProviderName>
  | ReturnType<typeof setRequestId>
  | ReturnType<typeof setCardType>
  | ReturnType<typeof setCardNumber>
  | ReturnType<typeof setFormRequestPatientId>
  | ReturnType<typeof setFormRequestTypeId>
  | ReturnType<typeof setFormRequestAuthorization>
  | ReturnType<typeof setFormRequestGovtId>
  | ReturnType<typeof setPatientForm>
  | ReturnType<typeof setFormRequestSupportingDocs>
  | ReturnType<typeof deleteFormSupportingDoc>
  | ReturnType<typeof setFormRequestPaymentMethod>
  | ReturnType<typeof setFormRequestPayment>
  | ReturnType<typeof setFormRequestLoading>
  | ReturnType<typeof setFormRequestReset>
  | ReturnType<typeof setFormRequestError>
  | ReturnType<typeof setPatientInfo>
  | ReturnType<typeof setFormRequestForms>
  | ReturnType<typeof setAuthType>
  | ReturnType<typeof setEstimateAuth>
  | ReturnType<typeof setShowPrompt>
  | ReturnType<typeof setFormRequestRid>
  | ReturnType<typeof setFormRequestFileData>
  | ReturnType<typeof setRequestDetails>;

type ThunkResult<R> = ThunkAction<R, State, undefined, Actions>;

export type FormRequestApiValues = {
  custodian_id: string;
  auth_name: string;
  auth_dob: string;
  auth_ssn: string;
  auth_signature: string;
  auth_signature_id: string;
  auth_print_name: string;
  auth_date: string;
  card_id: string;
  form_id?: string;
  form_record?: string;
  form_name?: string;
  dependent_id: string;
};

export const saveFormRequest = (data: any): ThunkResult<void> => async dispatch => {
  dispatch(setShowPrompt(false));
  dispatch(setFormRequestLoading(true));
  api2
    .post('/api/v2/request/form_request', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })(dispatch)
    .then(res => {
      dispatch(setRequestId(res.request_rid));
      dispatch(setFormRequestLoading(false));
      notifyCustomerSurveyRequestActivity({ requestId: res.request_id ?? res.request_rid });
    })
    .catch(error => {
      dispatch(setFormRequestError(error));
    });
};

export const draftFormRequest = (
  data: any,
  callback?: (error: boolean, message: string) => void,
): ThunkResult<void> => async dispatch => {
  if (!callback) dispatch(commonLoading());
  api2
    .post('/api/v2/request/form_request', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })(dispatch)
    .then(res => {
      if (callback) {
        callback(false, res.message);
        dispatch(setFormRequestRid(res.request_rid));
      } else dispatch(commonSuccess(res.message));
    })
    .catch(error => {
      if (callback) callback(true, error.message);
      else dispatch(commonError(error.message));
    });
};

export const abandonedFormRequest = (data: any): ThunkResult<void> => async dispatch => {
  dispatch(setShowPrompt(false));
  dispatch(setFormRequestReset());
  dispatch(commonLoading());
  api2
    .post('/api/v2/request/form_request/abandoned_draft_form_request', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })(dispatch)
    .then(res => dispatch(commonSuccess(res.message)))
    .catch(error => dispatch(commonError(error.message)));
};

export const sendFormMobileRequest = (params: any): ThunkResult<void> => async dispatch => {
  api2
    .get('/api/v2/authorizations/send_upload_government_document_link', { params })(dispatch)
    .then(res => dispatch(commonSuccess(res.message)))
    .catch(error => dispatch(commonError(error.message)));
};

export const getGovtId = (rid: number): ThunkResult<void> => async dispatch => {
  return api2
    .get(`/api/v2/authorizations/government_id?rid=${rid}`)(dispatch)
    .then(res => {
      if (res) {
        const { front_file, back_file } = res;

        dispatch(
          setFormRequestGovtId({
            frontFileId: front_file?.id,
            frontFileURL: front_file?.url,
            frontFileName: front_file?.name,
            backFileId: back_file?.id,
            backFileURL: back_file?.url,
            backFileName: back_file?.name,
          }),
          );
        }
      })
      .catch(error => console.error('error', error));
  };
  
export const sendFormPatientMobileRequest = (params: any): ThunkResult<void> => async dispatch => {
  api2
    .get('/api/v2/authorizations/send_patient_form_document_link',{params})(dispatch)
    .then(res => {
      dispatch(commonSuccess(res.message))
    })
    .catch(error => {
      dispatch(commonError(error.message))
    });
};

export const getPatientForm = (rid: number): ThunkResult<void> => async dispatch => {
  return api2
    .get(`/api/v2/authorizations/get_patient_form?rid=${rid}`)(dispatch)
    .then(res => {
      if (res) {
        const { front_file } = res;

        dispatch(
          setPatientForm({
            frontFileId: front_file?.id,
            frontFileURL: front_file?.url,
            frontFileName: front_file?.name,
          }),
        );
      }
    })
    .catch(error => console.error('error', error));
};

export const removeGovtIdDocument = (
  document_id: number,
  type: 'front_file' | 'back_file',
): ThunkResult<void> => async dispatch => {
  api2
    .delete(`/api/v2/authorizations/remove_government_id?document_id=${document_id}`)(dispatch)
    .then(res => {
      if (type === 'front_file') {
        dispatch(
          setFormRequestGovtId({
            frontFileId: undefined,
            frontFile: undefined,
            frontFileURL: undefined,
            frontFileName: undefined,
          }),
        );
      }
      if (type === 'back_file') {
        dispatch(
          setFormRequestGovtId({
            backFileId: undefined,
            backFile: undefined,
            backFileURL: undefined,
            backFileName: undefined,
          }),
        );
      }
    });
};

export const removePatientForm_id = (
  form_id: number
): ThunkResult<void> => async dispatch => {
  api2
    .delete(`/api/v2/authorizations/remove_patient_form?form_id=${form_id}`)(dispatch)
    .then(res => {
        dispatch(
          setPatientForm({
            frontFileId: undefined,
            frontFile: undefined,
            frontFileURL: undefined,
            frontFileName: undefined,
          }),
        );
    });
};
